import React from 'react';

type Props = {
  revealed?: boolean;
};

/** Компактное приглушённое превью шкалы до заполнения профиля */
export default function MarketProfileScalePreview({ revealed = false }: Props) {
  const markers = [
    { pos: 25, label: 'P25' },
    { pos: 50, label: 'P50' },
    { pos: 75, label: 'P75' },
  ];

  return (
    <div className={`dcf-mp-scale-preview ${revealed ? 'dcf-mp-scale-preview--revealed' : ''}`}>
      <div className="dcf-mp-scale-preview__track" aria-hidden="true">
        {markers.map((m) => (
          <div key={m.label} className="dcf-mp-scale-preview__tick" style={{ left: `${m.pos}%` }}>
            <span className="dcf-mp-scale-preview__tick-line" />
            <span className="dcf-mp-scale-preview__tick-label">{m.label}</span>
          </div>
        ))}
        {revealed && (
          <div className="dcf-mp-scale-preview__user" style={{ left: '58%' }}>
            <span className="dcf-mp-scale-preview__user-dot" />
          </div>
        )}
      </div>
      <p className="dcf-mp-scale-preview__caption">
        {revealed ? 'Ваше положение на шкале рынка' : 'Ваше положение откроется после заполнения'}
      </p>
    </div>
  );
}
